import {
  Building2,
  Heart,
  HelpCircle,
  PenLine,
  UserCircle,
  UserCog,
} from "lucide-react";

const customerNavigation = {
  navItems: [
    {
      label: "My Space",
      path: "/customer/myspace",
      icon: UserCircle,
      description: "Your personalized property activity and saved flow.",
    },
    {
      label: "Properties",
      path: "/customer/properties",
      icon: Building2,
      description: "Browse the latest property inventory and details.",
    },
    {
      label: "Saved",
      path: "/customer/saved",
      icon: Heart,
      description: "Revisit the homes and listings you bookmarked.",
    },
    {
      label: "Posts",
      path: "/customer/posts",
      icon: PenLine,
      description: "Explore shared posts and market updates.",
    },
    {
      label: "Profile",
      path: "/customer/profile",
      icon: UserCog,
      description: "Manage your account, documents, and payments.",
    },
  ],
  footerItems: [
    {
      label: "Help Center",
      path: "/help-center",
      icon: HelpCircle,
    },
  ],
};

export default customerNavigation;
